module.exports = __webpack_public_path__ + "img/cloud-sun-01.9eb8d0e4.svg";